import React from "react";
import PhotoSlider from "../components/photo-slider";

function Gallery() {
  return (
    <section id="gallery-page" className="py-2">
      <div className="container">
        <div className="one-card-container">
          <article className="card">
          <h2>Gallery</h2>
            <PhotoSlider />
          </article>
        </div>
      </div>
    </section>
  );
}

export default Gallery;
